import React, { Suspense, lazy, useState, useRef } from "react";
import {
  Tabs,
  Tab,
  Nav,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import styled from "styled-components";
import useUserDetails from "./useUserDetails";
import Preloader from "../../../components/Preloader";
import useCheckPermission from "../../../utils/checkPermission";
import NotificationIconContainer from "../../../components/NotificationIcon/NotificationIconContainer";
import PageBackButton from "../../../components/PageBackButton"

// Import other components normally
import BonusDetailModal from "./components/BonusDetailModal";
import DisableReason from "./components/DisableReason";
import ConfirmationModal, {
  DuplicateUserModal,
  ResetPasswordEmailModal,
  ResetUserPasswordModal,
  VerifyEmailModal,
} from "../../../components/ConfirmationModal";
import EditUserModal from "./components/EditUserModal";
import TagModal from "../../Tenant/UserDetails/components/TagModal";
import SendEmailModal from "./components/SendEmailModal";
import PromoCodeModal from "./components/PromoCodeModal";
import FreeSpinBonusModal from "../../../components/FreeSpinBonusModal/FreeSpinBonusModal";
import ManageMoney from "../../../components/ManageMoney";
import ManageBonusVariant from "../../../components/ManageBonusVariant";
import SportsBookTransactions from "../SportsBookTransactions";
import { DeleteConfirmationModal } from '../../../components/ConfirmationModal'


// Styled components for skeleton
const SkeletonLoader = styled.div`
  width: 200px;
  height: 32px;
  background-color: #e9ecef;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;

  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

// Using your existing UserNameSkeleton component
const UserNameSkeleton = () => (
  <div className="d-flex align-items-center">
    <h2 className="title-text">Player: &nbsp;</h2>
    <div className="mb-0 h2">
      <SkeletonLoader />
    </div>
  </div>
);

// Lazy load components that depend on userData
const Overview = lazy(() => import("./components/Overview"));
const UserWallet = lazy(() => import("./components/UserWallet"));
const CasinoTransactions = lazy(() =>
  import("./components/CasinoTransactions")
);
const TransactionBanking = lazy(() =>
  import("./components/TransactionBanking")
);
const RefferedUsers = lazy(() => import("./components/RefferedUsers"));

const UserDetails = (props) => {
  const {
    selectedTab,
    bonusList,
    userData,
    loading,
    showModal,
    selectedBonus,
    bonusDetail,
    bonusAmount,
    basicInfo,
    kycInfo,
    contactInfo,
    freespinModal,
    showManageMoneyModal,
    showRemoveAffiliate,
    setShowRemoveAffiliate,
    updateUserAffiliateLoading,
    addUserAffiliateLoading,
    showAddAffiliate,
    labelName,
    addAffiliateHandler,
    setShowAddAffiliate,
    removeAffiliateHandler,
    setBonusAmount,
    issueBonusHandler,
    setSelectedBonus,
    setShowModal,
    setSelectedTab,
    setShowManageMoneyModal,
    setFreeSpinModal,
    setIsInternalModal,
    isInternalModal,
    internalPlayerHandler,
    name,
    navigate,
    isActiveInactivemodalVisible,
    setActiveInactiveModal,
    updateUserStatus,
    verifyEmailModal,
    setVerifyEmailModal,
    handleVerifyEmail,
    setPasswordEmailModal,
    setUserPasswordModal,
    userPasswordModal,
    passwordEmailModal,
    handleResetPasswordEmail,
    handleResetUserPassword,
    editUserModal,
    setEditUserModal,
    limit,
    pageNo,
    setLimit,
    setPageNo,
    showTagModal,
    showDuplicateModal,
    setShowTagModal,
    setShowDuplicateModal,
    updateTags,
    tagOptions,
    setTagOptions,
    selectedTag,
    setSelectedTag,
    addTag,
    getDuplicateUsers,
    duplicateUsers,
    bonusLoading,
    setBonusLoading,
    sendEmailModal,
    setSendEmailModal,
    showPromoCodeModal,
    setShowPromoCodeModal,
    emailTemplates,
    sendEmail,
    sendPromoCode,
    showBonusModal,
    setShowBonusModal,
    showAffiliateModal,
    setShowAffiliateModal,
    makeAffiliateHandler,
    setShowVerifyOrSuspiciousUserModal,
    showVerifyOrSuspiciousUserModal,
    isVerifyUser,
    setIsVerifyUser,
    handleVerifyOrSuspiciousUser,
    getSuspiciousButtonText,
    getSuspiciousModalSubtitle,
    filterEmailTemplate,
    setDeletePlayer,
    deletePlayer,
    onHandleDeleteYes
  } = useUserDetails();

  const { isHidden } = useCheckPermission();

  const headerRef = useRef(null);
  const tabRef = useRef(null);
console.log({basicInfo} , "basicInfo >>> 12333333333333333333")
  return (
    <>
      <div className="section-header-wrap mt-n3 mx-n3" ref={headerRef}>
        <Row className="align-items-center justify-content-between">
          <Col lg={8} xs={12}>

            {!loading && userData ? (
              <div className='backbtn'>
              <PageBackButton />
              <div className="d-flex align-items-center">
                <h2 className="title-text"> Player: &nbsp;</h2>
                <h5 className="mb-0 h2">
                  {userData.firstName} {userData.lastName}
                </h5>
              </div>
              </div>
             
            ) : (
              <UserNameSkeleton />
            )}
          </Col>
          <Col lg={4} className="text-end d-none d-lg-block">
            <NotificationIconContainer />
          </Col>
        </Row>

        {/* Notification row for smaller screens */}
        <Row className="d-lg-none mt-2">
          <Col xs={12} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>
      <div >
        <Tab.Container
          activeKey={selectedTab}
          onSelect={(tab) => setSelectedTab(tab)}

        >
          <div className="d-flex align-items-end justify-content-between mb-3 flex-wrap border-bottom" ref={tabRef}>
            <Nav variant="tabs" className="nav-light flex-grow-1">
              <Nav.Item>
                <Nav.Link eventKey="overview">Overview</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="wallet">Wallet</Nav.Link>
              </Nav.Item>
              {!isHidden({ module: { key: "Transactions", value: "R" } }) && (
                <Nav.Item>
                  <Nav.Link eventKey="casino-transactions">Bet History</Nav.Link>
                </Nav.Item>
              )}
              {!isHidden({ module: { key: "Transactions", value: "R" } }) && (
                <Nav.Item>
                  <Nav.Link eventKey="transactions-banking">
                    Transactions
                  </Nav.Link>
                </Nav.Item>
              )}

              {!isHidden({ module: { key: "SportsBook", value: "R" } }) && (
                <Nav.Item>
                  <Nav.Link eventKey="SportsBookTransactions">
                    Sports Book
                  </Nav.Link>
                </Nav.Item>
              )}


              {userData?.kycStatus === "APPROVED" && (
                <Nav.Item>
                  <Nav.Link eventKey="Refferal Users">Refferal Users</Nav.Link>
                </Nav.Item>
              )}

              {!userData?.isVerified && !isHidden({ module: { key: "Users", value: "U" } }) && (
                <Nav.Item className="ms-auto">
                  <Button
                    variant="success"
                    onClick={() => {
                      setShowVerifyOrSuspiciousUserModal(true);
                      setIsVerifyUser(true);
                    }}
                    disabled={loading || !userData}
                    size="sm"
                    className="mt-1 mb-1 px-3 py-2"
                  >
                    Verify User
                  </Button>
                </Nav.Item>
              )}
            </Nav>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="overview">
              <div className="mt-5">
                <Row className="mt-3 d-flex">
                  <Suspense fallback={<Preloader />}>
                    <Overview
                      basicInfo={basicInfo}
                      kycInfo={kycInfo}
                      contactInfo={contactInfo}
                      userLimits={userData?.userLimit}
                      user={userData}
                      setActiveInactiveModal={setActiveInactiveModal}
                      setIsInternalModal={setIsInternalModal}
                      setVerifyEmailModal={setVerifyEmailModal}
                      setShowModal={setShowModal}
                      setFreeSpinModal={setFreeSpinModal}
                      setShowManageMoneyModal={setShowManageMoneyModal}
                      setShowAddAffiliate={setShowAddAffiliate}
                      addUserAffiliateLoading={addUserAffiliateLoading}
                      setShowRemoveAffiliate={setShowRemoveAffiliate}
                      updateUserAffiliateLoading={updateUserAffiliateLoading}
                      isHidden={isHidden}
                      setPasswordEmail={setPasswordEmailModal}
                      setUserPassword={setUserPasswordModal}
                      setEditModal={setEditUserModal}
                      addTag={addTag}
                      getDuplicateUsers={getDuplicateUsers}
                      duplicateUsers={duplicateUsers}
                      sendEmailModal={sendEmailModal}
                      setSendEmailModal={setSendEmailModal}
                      setShowPromoCodeModal={setShowPromoCodeModal}
                      setShowBonusModal={setShowBonusModal}
                      setShowAffiliateModal={setShowAffiliateModal}
                      setShowVerifyOrSuspiciousUserModal={
                        setShowVerifyOrSuspiciousUserModal
                      }
                      setIsVerifyUser={setIsVerifyUser}
                      getSuspiciousButtonText={getSuspiciousButtonText}
                      setDeletePlayer={setDeletePlayer}
                      deletePlayer={deletePlayer}


                    />
                  </Suspense>
                </Row>
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey="wallet">
              <div className="mt-5">
                <Row className="mt-3 d-fle text-right">
                  <Suspense fallback={<Preloader />}>
                    <UserWallet myUserData={userData} />
                  </Suspense>
                </Row>
              </div>
            </Tab.Pane>

            {!isHidden({ module: { key: "SportsBook", value: "R" } }) &&
            <Tab.Pane eventKey="SportsBookTransactions">
              {/* <div className="mt-5"> */}
                <Row className="mt-3  text-right">
                  {/* <Suspense fallback={<Preloader />}> */}
                    <SportsBookTransactions isPlayerData={true} playerData={userData} tabRef={tabRef} headerRef={headerRef} selectedTab={selectedTab}/>
                  {/* </Suspense> */}
                </Row>
              {/* </div> */}
            </Tab.Pane> }

            {!isHidden({ module: { key: "Transactions", value: "R" } }) && 
            (
              <Tab.Pane eventKey="casino-transactions">
                <div className="mt-5">
                  <Row className="mt-3 d-flex m-0">
                    <Suspense fallback={<Preloader />}>
                      <CasinoTransactions headerRef={headerRef} tabRef={tabRef} selectedTab={selectedTab} />
                    </Suspense>
                  </Row>
                </div>
              </Tab.Pane>
            )}

            {!isHidden({ module: { key: "Transactions", value: "R" } }) && (
              <Tab.Pane eventKey="transactions-banking">
                <div className="mt-5">
                  <Row className="mt-3 d-flex m-0">
                    <Suspense fallback={<Preloader />}>
                      <TransactionBanking headerRef={headerRef} tabRef={tabRef} selectedTab={selectedTab} />
                    </Suspense>
                  </Row>
                </div>
              </Tab.Pane>
            )}

            {userData?.kycStatus === "APPROVED" && (
              <Tab.Pane eventKey="Refferal Users">
                <div className="mt-5">
                  <Row className="mt-3 d-flex m-0">
                    <Suspense fallback={<Preloader />}>
                      <RefferedUsers />
                    </Suspense>
                  </Row>
                </div>
              </Tab.Pane>
            )}
          </Tab.Content>
        </Tab.Container>
      </div>
      {/* Modal for giving bonus */}
      <Modal size="xl" show={showModal}>
        <Modal.Header className="justify-content-center">
          <h4>
            Give Bonus to '{userData?.firstName} {userData?.lastName}'
          </h4>
        </Modal.Header>
        <Modal.Body>
          {bonusList?.length > 0 && (
            <Row>
              <Col style={{ maxWidth: "35%" }}>
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  AVAILABLE BONUSES
                </p>
                <div style={{ maxHeight: "500px", overflow: "auto" }}>
                  <Table>
                    <tbody>
                      {bonusList?.length > 0 &&
                        bonusList?.map((item, i) => {
                          return (
                            <tr key={`player-modal-bonus-history ${i}`}>
                              <td>
                                <Form.Check
                                  readOnly
                                  type="checkbox"
                                  label={item?.promotionTitle?.EN}
                                  checked={
                                    item?.bonusId === selectedBonus?.bonusId
                                  }
                                  onClick={() => {
                                    setBonusLoading(true);
                                    setSelectedBonus(item);
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col style={{ maxWidth: "65%" }}>
                <p
                  className="text-center"
                  style={{ fontSize: "14px", fontWeight: "bold" }}
                >
                  BONUS DETAILS
                </p>
                <BonusDetailModal
                  bonusAmount={bonusAmount}
                  bonusDetail={bonusDetail}
                  setBonusAmount={setBonusAmount}
                  bonusLoading={bonusLoading}
                />
              </Col>
            </Row>
          )}
          {bonusList?.length === 0 && (
            <div className="text-danger text-center">No Bonuses Found</div>
          )}
        </Modal.Body>
        <Modal.Footer
          className={`d-flex justify-content-${bonusList?.length > 0 ? "between" : "center"
            }`}
        >
          <Button
            className="m-2"
            variant="outline-warning"
            onClick={() => {
              setShowModal(false);
              setBonusAmount("");
            }}
          >
            Cancel
          </Button>
          {bonusList?.length > 0 && (
            <Button
              className="m-2"
              variant="outline-success"
              style={{ width: "75px" }}
              onClick={issueBonusHandler}
            >
              Add
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Other modals */}
      <Modal show={isInternalModal}>
        <Modal.Header>
          <h4>
            Mark '{userData?.firstName} {userData?.lastName}' as Internal
          </h4>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you really want to mark{" "}
            <strong>
              {userData?.firstName} {userData?.lastName}
            </strong>{" "}
            as Internal?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="m-2"
            variant="outline-warning"
            onClick={() => {
              setIsInternalModal(false);
            }}
          >
            No
          </Button>
          <Button
            className="m-2"
            variant="outline-success"
            style={{ width: "75px" }}
            onClick={internalPlayerHandler}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {freespinModal && (
        <FreeSpinBonusModal
          show={freespinModal}
          setShow={setFreeSpinModal}
          userData={userData}
        />
      )}

      <ManageMoney
        show={showManageMoneyModal}
        handleClose={setShowManageMoneyModal}
        user={userData}
      />

      {showBonusModal && (
        <ManageBonusVariant
          show={showBonusModal}
          handleClose={setShowBonusModal}
          user={userData}
        />
      )}

      <Modal show={showAddAffiliate}>
        <Modal.Header className="d-flex justify-content-center">
          <h4>
            Add '{userData?.firstName} {userData?.lastName}' as Affiliate
          </h4>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <p>
            Do you really want to link{" "}
            <strong>
              {userData?.firstName} {userData?.lastName}
            </strong>{" "}
            as Affiliate using token{" "}
            <strong>'{userData?.trackingToken}'</strong> ?
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            className="m-2"
            variant="outline-warning"
            onClick={() => {
              setShowAddAffiliate(false);
            }}
          >
            No
          </Button>
          <Button
            className="m-2"
            variant="outline-success"
            style={{ width: "75px" }}
            onClick={addAffiliateHandler}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRemoveAffiliate}>
        <Modal.Header className="d-flex justify-content-center">
          <h4>
            Remove '{userData?.firstName} {userData?.lastName}' from Affiliate
          </h4>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <p className="text-center">
            Do you really want to remove{" "}
            <strong>
              {userData?.firstName} {userData?.lastName}
            </strong>{" "}
            from Affiliate(<strong>{userData?.affiliate?.username}</strong>) (
            <strong>{userData?.trackingToken}</strong>) ?
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            className="m-2"
            variant="outline-warning"
            onClick={() => {
              setShowRemoveAffiliate((prev) => false);
            }}
          >
            No
          </Button>
          <Button
            className="m-2"
            variant="outline-success"
            style={{
              width: "75px",
            }}
            onClick={() => {
              setShowRemoveAffiliate((prev) => false);
              removeAffiliateHandler();
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAffiliateModal}>
        <Modal.Header>
          <h4>
            Make {userData?.firstName} {userData?.lastName} as affiliate
          </h4>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you really want to make {userData?.firstName}{" "}
            {userData?.lastName} as affiliate?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="m-2"
            variant="outline-warning"
            onClick={() => {
              setShowAffiliateModal(false);
            }}
          >
            No
          </Button>
          <Button
            className="m-2"
            variant="outline-success"
            style={{ width: "75px" }}
            onClick={() => {
              makeAffiliateHandler();
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal
        show={showVerifyOrSuspiciousUserModal}
        setShow={setShowVerifyOrSuspiciousUserModal}
        handleYes={() => {
          handleVerifyOrSuspiciousUser(userData);
          setShowVerifyOrSuspiciousUserModal(false);
        }}
        title={"Are you sure?"}
        subTitle={
          getSuspiciousModalSubtitle
            ? getSuspiciousModalSubtitle(userData, isVerifyUser)
            : (isVerifyUser
              ? `Confirm verification for ${userData?.firstName} ${userData?.lastName}?`
              : `${userData?.isSuspicious ? 'Mark' : 'Flag'} ${userData?.firstName} ${userData?.lastName} as ${userData?.isSuspicious ? 'trusted' : 'suspicious'} user?`)
        }
      />

      {userData?.isActive ? (
        <DisableReason
          show={isActiveInactivemodalVisible}
          handleClose={() => setActiveInactiveModal(false)}
          markUserStatusInactive={updateUserStatus}
          name={`${userData?.firstName} ${userData?.lastName} (${userData?.email})`}
        />
      ) : (
        <ConfirmationModal
          show={isActiveInactivemodalVisible}
          setShow={setActiveInactiveModal}
          handleYes={() => {
            updateUserStatus();
            setActiveInactiveModal(false);
          }}
          title={"Are you sure?"}
          subTitle={`You want to mark ${userData?.firstName || ""} ${userData?.lastName || ""
            } as ${userData?.isActive ? "In-Active" : "Active"}?`}
        />
      )}

      {verifyEmailModal && (
        <VerifyEmailModal
          show={verifyEmailModal}
          setShow={setVerifyEmailModal}
          userData={userData}
          handleVerifyEmail={handleVerifyEmail}
        />
      )}

      {passwordEmailModal && (
        <ResetPasswordEmailModal
          show={passwordEmailModal}
          setShow={setPasswordEmailModal}
          userData={userData}
          handleResetPasswordEmail={handleResetPasswordEmail}
        />
      )}

      {showTagModal && (
        <TagModal
          show={showTagModal}
          handleClose={setShowTagModal}
          updateTags={updateTags}
          tagOptions={tagOptions}
          setTagOptions={setTagOptions}
          selectedTag={selectedTag}
          setSelectedTag={setSelectedTag}
          name={`${userData?.firstName} ${userData?.lastName}`}
        />
      )}
      {showDuplicateModal && (
        <DuplicateUserModal
          show={showDuplicateModal}
          setShow={setShowDuplicateModal}
          limit={limit}
          pageNo={pageNo}
          setLimit={setLimit}
          setPageNo={setPageNo}
        />
      )}

      {userPasswordModal && (
        <ResetUserPasswordModal
          show={userPasswordModal}
          setShow={setUserPasswordModal}
          userData={userData}
          handleResetUserPassword={handleResetUserPassword}
        />
      )}
      {sendEmailModal && (
        <SendEmailModal
          show={sendEmailModal}
          handleClose={() => setSendEmailModal(false)}
          emailTemplates={emailTemplates}
          handleSendUserEmail={sendEmail}
        />
      )}

      {showPromoCodeModal && (
        <PromoCodeModal
          show={showPromoCodeModal}
          handleClose={() => setShowPromoCodeModal(false)}
          handleSendPromoCode={sendPromoCode}
          name={`${userData?.firstName || ''} ${userData?.lastName || ''}`.trim()}
        />
      )}

      {editUserModal && (
        <EditUserModal
          show={editUserModal}
          setShow={setEditUserModal}
          userData={userData}
        />
      )}

      {
        deletePlayer?.isOpen &&
        <DeleteConfirmationModal
          handleDeleteYes={onHandleDeleteYes}
          setDeleteModalShow={setDeletePlayer}
          deleteModalShow={deletePlayer?.isOpen}
          name={`Player ${deletePlayer?.data?.username}`}
        />
      }


    </>
  );
};

export default UserDetails;
